var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/apis/apShareData/index.ts
import UA from "@ali/tbm-ua";

// src/apis/apShareData/apShareData.nebula.ap.ts
import ua from "@ali/tbm-ua";
import { callNebula, noop } from "@ali/abridge";
import { getMiniAppId } from "@ali/tbm-util";
var DefaultOptions = {
  // Android同key不同business有bug，通过type解决
  type: ua.isMovieShow ? "user" : "common",
  // 为了和小程序共享存储
  business: getMiniAppId()
};
var formatter = (options) => {
  if (typeof options.value === "string")
    return options;
  try {
    options.value = JSON.stringify(options.value);
  } catch (e) {
    console.log(e);
  }
  return options;
};
var setAPShareDataByAnt = (options) => callNebula("setAPDataStorage", __spreadValues(__spreadValues({}, DefaultOptions), formatter(options)));
var getAPShareDataByAnt = (options) => callNebula("getAPDataStorage", __spreadValues(__spreadValues({}, DefaultOptions), options));
var removeAPShareDataByAnt = (options) => callNebula("removeAPDataStorage", __spreadValues(__spreadValues({}, DefaultOptions), options));
var set = (options, callback = noop) => {
  if (typeof callback === "function" && callback !== noop) {
    return setAPShareDataByAnt(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return setAPShareDataByAnt(options);
};
var get = (options, callback = noop) => {
  if (typeof callback === "function" && callback !== noop) {
    return getAPShareDataByAnt(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return getAPShareDataByAnt(options);
};
var remove = (options, callback = noop) => {
  if (typeof callback === "function" && callback !== noop) {
    return removeAPShareDataByAnt(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return removeAPShareDataByAnt(options);
};
var apShareData = {
  get,
  set,
  remove
};

// src/apis/apShareData/index.ts
import { notSupportForObjForm as notSupport } from "@ali/abridge";
var _apShareData;
if (UA.isNebula && UA.isAP) {
  _apShareData = apShareData;
}
if (!_apShareData) {
  _apShareData = notSupport;
}
var apShareData2 = {
  get get() {
    if (_apShareData["get"]) {
      return _apShareData["get"];
    } else {
      return notSupport;
    }
  },
  get set() {
    if (_apShareData["set"]) {
      return _apShareData["set"];
    } else {
      return notSupport;
    }
  },
  get remove() {
    if (_apShareData["remove"]) {
      return _apShareData["remove"];
    } else {
      return notSupport;
    }
  }
};
export {
  apShareData2 as apShareData
};
